import React, { ChangeEvent, useRef } from "react"
import { LuPaperclip } from "react-icons/lu";
import { useFileUpload } from '../../../../context/UploadFilesContext'


interface FileUploadButtonProps {
  onFileSelect: (file: File) => void;
  token: string
}


export const FileButton = ({ onFileSelect, token }: FileUploadButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const { processFiles, seIsBigDuration } = useFileUpload();

  const MAX_FILE_SIZE = 16 * 1024 * 1024; // 16MB

  return (
    <div className="flex items-center gap-2">

      <input
        type="file"
        accept=".pdf, .doc, .docx, image/*, .mp4"
        ref={fileInputRef}
        multiple
        style={{ display: 'none' }}
        onChange={e => {

          const files = Array.from(e.target.files || []);

          const valid = files.filter(f => f.size <= MAX_FILE_SIZE);

          if (valid.length !== files.length) {
            seIsBigDuration(true)
            // alert("O tamanho do vídeo é maior do que permitido (16 Megas), não pode ser enviado por este canal!");
            return
          }

          processFiles(Array.from(e.target.files ?? []), token)

        }}
      />

      <button onClick={() => fileInputRef.current?.click()}>
        <LuPaperclip size={14} color={'#696969'} />
      </button>


    </div>
  )
}

